import { IStateIndicator, IUserSettings } from "models";
import { dashboardApiService } from "./dashboardApiService";
import { max } from "moment";

const routes = {
	pingDashboard: "api/dashboard/ping",
	getStateIndicatorReferences: "api/dashboard/getStateIndicatorReferences",
	getMdtDashboard: "api/dashboard/getMdtDashboard",
	getMdtDashboardReferences: "api/dashboard/getMdtDashboardReferences",
	getMdtDashboardDataQualityIndicators: "api/dashboard/getMdtDashboardDataQualityIndicators",
	getMdtDashboardDataQualityComparisons: "api/dashboard/getMdtDashboardDataQualityComparisons",
	getMdtDashboardSurvival: "api/dashboard/getMdtDashboardSurvival",
	getMdtDashboardKMSurvival: "api/dashboard/getMdtDashboardKMSurvival",
	getNoMdtDashboard: "api/dashboard/getNoMdtDashboard",
	getNoMdtDashboardReferences: "api/dashboard/getNoMdtDashboardReferences",
	getNoMdtDashboardSurvival: "api/dashboard/getNoMdtDashboardSurvival",
	getNoMdtDashboardKMSurvival: "api/dashboard/getNoMdtDashboardKMSurvival",
	getBreastDashboard: "api/dashboard/getBreastDashboard2",
	getBreastDashboardReferences: "api/dashboard/getBreastDashboardReferences",
	getCRCDashboard: "api/dashboard/getCRCDashboard2",
	getCRCDashboardReferences: "api/dashboard/getCRCDashboardReferences",
	getLungDashboard: "api/dashboard/getLungDashboard",
	getLungDashboardReferences: "api/dashboard/getLungDashboardReferences",
	getBrainDashboard: "api/dashboard/getBrainDashboard",
	getBrainDashboardReferences: "api/dashboard/getBrainDashboardReferences",
	getHeadAndNeckDashboard: "api/dashboard/getHeadAndNeckDashboard",
	getHeadAndNeckDashboardReferences: "api/dashboard/getHeadAndNeckDashboardReferences",
	getYouthCancerDashboard: "api/dashboard/getYouthCancerDashboard",
	getYouthCancerDashboardReferences: "api/dashboard/getYouthCancerDashboardReferences",
	getAMLDashboard: "api/dashboard/getAMLDashboard",
	getAMLDashboardReferences: "api/dashboard/getAMLDashboardReferences",
	getUserSettings: "api/dashboard/userSettings",
	getMdtDashboardNoProfileIndicators: "api/dashboard/getMdtDashboardNoProfileIndicators"
}

export const pingDashboard = () =>
	dashboardApiService.get(routes.pingDashboard)

let stateWideIndicators: IStateIndicator[] | null = null;

export const getStateIndicatorReferences = async (cancerName: string, year?: number) => {
	if (stateWideIndicators == null)
		stateWideIndicators = await (dashboardApiService.get(routes.getStateIndicatorReferences)) as any;

	// option 1 but that means you need to change every dashboard because instead of just a string it is an object with numerator, denominator and percentage
	// let dictionary: { [key: string]: { numerator: string, denominator: string, percentage: string } }
	// 	= Object.assign({}, ...res.filter(x => x.cancer.toLowerCase() == cancerName).map((x) => ({ [x.indicator]: { numerator: x.numerator, denominator: x.denominator, percentage: x.percentage } })));

	// option 2 make it all a string, might look wonky not sure if you can insert newlines like this
	if (stateWideIndicators != null) {

		let dictionary = Object.assign({}, ...stateWideIndicators.filter(x => x.cancer.toLowerCase().includes(cancerName) && (x.endYear == year || !year)).map(x =>
			(x.rateText2 !== null ? ({ [x.indicator]: `${x.rateText1}\n${x.rateText2}` }) : ({ [x.indicator]: `${x.rateText1}` }))
		));
		
		return dictionary;
	}


	return {};
}


export const getMdtDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getMdtDashboard, { showAll });

export const getMdtDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getMdtDashboardReferences, { showAll });

export const getMdtDashboardDataQualityIndicators = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getMdtDashboardDataQualityIndicators, { showAll });

export const getMdtDashboardDataQualityComparisons = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getMdtDashboardDataQualityComparisons, { showAll });

export const getMdtDashboardNoProfileIndicators = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getMdtDashboardNoProfileIndicators, { showAll });

export const getMdtDashboardSurvival = (showAll: boolean = false, service: any, primarySite: any) =>
	dashboardApiService.post(routes.getMdtDashboardSurvival, { showAll, service, primarySite });

export const getMdtDashboardKMSurvival = (showAll: boolean = false, service: any, primarySite: any) =>
	dashboardApiService.post(routes.getMdtDashboardKMSurvival, { showAll, service, primarySite });

export const getNoMdtDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getNoMdtDashboard, { showAll });

export const getNoMdtDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getNoMdtDashboardReferences, { showAll });

export const getNoMdtDashboardSurvival = (showAll: boolean = false, service: any, primarySite: any) =>
	dashboardApiService.post(routes.getNoMdtDashboardSurvival, { showAll, service, primarySite });

export const getNoMdtDashboardKMSurvival = (showAll: boolean = false, service: any, primarySite: any) =>
	dashboardApiService.post(routes.getNoMdtDashboardKMSurvival, { showAll, service, primarySite });

export const getBreastDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getBreastDashboard, { showAll });

export const getBreastDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getBreastDashboardReferences, { showAll });

export const getCRCDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getCRCDashboard, { showAll });

export const getCRCDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getCRCDashboardReferences, { showAll });

export const getLungDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getLungDashboard, { showAll });

export const getLungDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getLungDashboardReferences, { showAll });

export const getBrainDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getBrainDashboard, { showAll });

export const getBrainDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getBrainDashboardReferences, { showAll });

export const getHeadAndNeckDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getHeadAndNeckDashboard, { showAll });

export const getHeadAndNeckDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getHeadAndNeckDashboardReferences, { showAll });

export const getYouthCancerDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getYouthCancerDashboard, { showAll });

export const getYouthCancerDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getYouthCancerDashboardReferences, { showAll });
export const getAMLDashboard = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getAMLDashboard, { showAll });

export const getAMLDashboardReferences = (showAll: boolean = false) =>
	dashboardApiService.post(routes.getAMLDashboardReferences, { showAll });

export const getUserSettings = () =>
	dashboardApiService.get(routes.getUserSettings) as Promise<IUserSettings>;
